import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'uex-drawer-title',
  templateUrl: './title.component.html'
})
export class DrawerTitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-drawer-title]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-drawer-title modal-title'
  }
})
export class DrawerHeadingTitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
